import {AmountRangePickerComponent} from './amountrangepicker.component';

export const AMOUNT_RANGE_COMPONENTS = [
    AmountRangePickerComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/amount/index.ts